module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('b-field', {
    attrs: {
      "label": "First name",
      "type": {
        'is-danger': _vm.errors.has('firstname')
      },
      "message": _vm.errors.first('firstname')
    }
  }, [_c('b-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "firstname"
    },
    model: {
      value: (_vm.firstname),
      callback: function($$v) {
        _vm.firstname = $$v
      },
      expression: "firstname"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Last name",
      "type": {
        'is-danger': _vm.errors.has('lastname')
      },
      "message": _vm.errors.first('lastname')
    }
  }, [_c('b-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "lastname"
    },
    model: {
      value: (_vm.lastname),
      callback: function($$v) {
        _vm.lastname = $$v
      },
      expression: "lastname"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Age",
      "type": {
        'is-danger': _vm.errors.has('age')
      },
      "message": _vm.errors.first('age')
    }
  }, [_c('b-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|integer|between:18,65'),
      expression: "'required|integer|between:18,65'"
    }],
    attrs: {
      "type": "number",
      "name": "age"
    },
    model: {
      value: (_vm.age),
      callback: function($$v) {
        _vm.age = $$v
      },
      expression: "age"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Gender",
      "addons": false,
      "type": {
        'is-danger': _vm.errors.has('gender')
      },
      "message": _vm.errors.first('gender')
    }
  }, [_c('b-radio', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "gender",
      "native-value": "M"
    },
    model: {
      value: (_vm.gender),
      callback: function($$v) {
        _vm.gender = $$v
      },
      expression: "gender"
    }
  }, [_vm._v("\n                    Male\n                ")]), _vm._v(" "), _c('b-radio', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "gender",
      "native-value": "F"
    },
    model: {
      value: (_vm.gender),
      callback: function($$v) {
        _vm.gender = $$v
      },
      expression: "gender"
    }
  }, [_vm._v("\n                    Female\n                ")])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Username",
      "type": {
        'is-danger': _vm.errors.has('username')
      },
      "message": _vm.errors.first('username')
    }
  }, [_c('b-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|alpha'),
      expression: "'required|alpha'"
    }],
    attrs: {
      "type": "text",
      "name": "username"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Password",
      "type": {
        'is-danger': _vm.errors.has('password')
      },
      "message": _vm.errors.first('password')
    }
  }, [_c('b-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8'),
      expression: "'required|min:8'"
    }],
    attrs: {
      "type": "password",
      "name": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Confirm password",
      "type": {
        'is-danger': _vm.errors.has('confirm-password')
      },
      "message": [{
        'The confirm password field is required': _vm.errors.firstByRule('confirm-password', 'required'),
        'The confirm password is not valid': _vm.errors.firstByRule('confirm-password', 'is')
      }]
    }
  }, [_c('b-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        is: _vm.password
      }),
      expression: "{ required: true, is: password }"
    }],
    attrs: {
      "type": "password",
      "name": "confirm-password"
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Where did you find us ?",
      "type": {
        'is-danger': _vm.errors.has('question')
      },
      "message": _vm.errors.first('question')
    }
  }, [_c('b-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "question",
      "placeholder": "Select an option"
    },
    model: {
      value: (_vm.question),
      callback: function($$v) {
        _vm.question = $$v
      },
      expression: "question"
    }
  }, [_c('option', {
    attrs: {
      "value": "google"
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "github"
    }
  }, [_vm._v("Github")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v("Other")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "",
      "type": {
        'is-danger': _vm.errors.has('flag-terms')
      },
      "message": {
        'Please check this box to proceed': _vm.errors.firstByRule('flag-terms', 'required')
      }
    }
  }, [_c('b-checkbox', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required:false'),
      expression: "'required:false'"
    }],
    attrs: {
      "name": "flag-terms"
    },
    model: {
      value: (_vm.flagTerms),
      callback: function($$v) {
        _vm.flagTerms = $$v
      },
      expression: "flagTerms"
    }
  }, [_vm._v("\n                    I agree to the terms and conditions\n                ")])], 1), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Submit ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e827538"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/extensions/veevalidate/examples/ExSimple.vue
// module id = 1296
// module chunks = 41 52